export const STATUS_LOGIC_MODES = { LEGACY: 0, ALERT_ACTION: 1 };
export const STATUS_DISPLAY_KINDS = { GRADIENT_CIRCLE: 11, GRADIENT_CIRCLE_WITH_TEXT: 12 };

const gradientDisplayOptions = [
    { value: STATUS_DISPLAY_KINDS.GRADIENT_CIRCLE, label: "漸層圓形燈號（無字）" },
    { value: STATUS_DISPLAY_KINDS.GRADIENT_CIRCLE_WITH_TEXT, label: "漸層圓形燈號（有字）" }
];

export const statusLogicOptions = [
    { value: 0, label: "原有模式（紅警戒、黃無訊、綠正常）" },
    { value: 1, label: "黃警紅行（黃警戒、紅行動、綠正常、灰無訊）" }
];

const lights = {
    green: { color: "green", colorName: "綠", label: "正常", background: "#90ee90", foreground: "#153819" },
    yellow: { color: "yellow", colorName: "黃", label: "超過警戒值", background: "#ffff00", foreground: "#333300" },
    red: { color: "red", colorName: "紅", label: "超過行動值", background: "#ff0000", foreground: "#ffffff" },
    gray: { color: "gray", colorName: "灰", label: "無訊號", background: "#6b7280", foreground: "#ffffff" }
};

export const getStatusLogicMode = project =>
    Number(project?.projectStatusLogicMode ?? project?.statusLogicMode) === STATUS_LOGIC_MODES.ALERT_ACTION
        ? STATUS_LOGIC_MODES.ALERT_ACTION : STATUS_LOGIC_MODES.LEGACY;

export const getStatusLight = (entry, project) => {
    const mode = getStatusLogicMode(project);
    const noSignal = entry?.value == null || entry.value === -99999;
    const level = Number(entry?.exceedWarning) || 0;
    if (noSignal) {
        return mode === STATUS_LOGIC_MODES.ALERT_ACTION ? lights.gray
            : { ...lights.yellow, label: "儀器故障，或無訊號" };
    }
    if (level > 0) {
        return mode === STATUS_LOGIC_MODES.ALERT_ACTION
            ? (level >= 4 ? lights.red : lights.yellow)
            : { ...lights.red, label: "超過警戒值或行動值" };
    }
    return lights.green;
};

export const getStatusLegend = project => getStatusLogicMode(project) === STATUS_LOGIC_MODES.ALERT_ACTION
    ? [lights.yellow, lights.red, lights.green, lights.gray]
    : [{ ...lights.red, label: "超過警戒值或行動值" },
        { ...lights.yellow, label: "儀器故障，或無訊號" }, lights.green];

export const getLightFilterOptions = project => [
    { value: "all", caption: "全部燈號" },
    ...getStatusLegend(project).map(light => ({ value: light.color, caption: `${light.colorName}：${light.label}` })),
    { value: "abnormal", caption: "所有異常燈號" }
];

export const matchesLightFilter = (entry, filter, project) => {
    if (!filter || filter === "all") return true;
    const light = getStatusLight(entry, project);
    return filter === "abnormal" ? light.color !== "green" : light.color === filter;
};

const legacyDisplayOptions = [
    { value: 0, label: "預設" }, { value: 1, label: "GeoNow 樣式" },
    { value: 7, label: "經典燈號 (XS)" }, { value: 8, label: "經典燈號 (S)" },
    { value: 2, label: "經典燈號 (M)" }, { value: 9, label: "經典燈號 (L)" },
    { value: 10, label: "經典燈號 (XL)" }, { value: 3, label: "繪文字: 人臉01" },
    { value: 4, label: "繪文字: 人臉02" }, { value: 5, label: "繪文字: 符號01" },
    { value: 6, label: "繪文字: 符號02" }, ...gradientDisplayOptions
];

export const getStatusDisplayOptions = project => getStatusLogicMode(project) === STATUS_LOGIC_MODES.ALERT_ACTION
    ? [{ value: 0, label: "預設（色塊與文字）" }, { value: 1, label: "色塊" }, { value: 2, label: "文字" }, ...gradientDisplayOptions]
    : legacyDisplayOptions;

export const getStatusDisplayKind = project => Number(getStatusLogicMode(project) === STATUS_LOGIC_MODES.ALERT_ACTION
    ? project?.projectAlertActionStatusDisplayKind ?? project?.alertActionStatusDisplayKind ?? 0
    : project?.projectStatusDisplayKind ?? project?.statusDisplayKind ?? 0);

// Scores remain semantic so co-located markers can select the most severe reading.
export const getStatusLightForScore = (score, project) => getStatusLight({
    value: score === 0.5 ? null : 0,
    exceedWarning: score === 0.5 ? 0 : score
}, project);
